import React from 'react';
import './error404.scss';
import ImgError from '../../assets/svg/404.svg';

const Error404 = () => {
    return(
        <div className="gb-cont-page-error">
            <div className="gb-page-error">
                <h1 className="gb-page-error-h1">Oops!</h1>
                <h2 className="gb-page-error-h2">Página não encontrada :(</h2>
                <p className="gb-page-error-p">A página que você está<br/>procurando não existe<br/>ou foi removida.</p>

                <div className="gb-page-error-row">
                    <div><a href="/home" className="btn gb-button">Voltar à Tela Inicial</a></div>
                    <img src={ImgError} className="gb-page-error-svg"/>
                </div>
            </div>
        </div>
    )
}

export default Error404;